import styled from '@emotion/styled';
import {Button, Container as ContainerUI, colors} from 'ui';

export const Container = styled(ContainerUI)({
  backgroundColor: colors.darkBrown,
});

export const SlideContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundSize: 'cover',
  height: ['100vh', '100dvh'],
  width: '100%',
  maxWidth: '100vw',
});

export const SlideText = styled('div')({
  position: 'relative',
  zIndex: 99_999,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingLeft: 20,
  paddingRight: 20,
});

export const ButtonWide = styled(Button)({
  width: '100%',
  textDecoration: 'none',
});

export const SignupHint = styled('p')({
  margin: '0 0 16px',
  color: colors.white,
  fontSize: 14,
  lineHeight: '20px',
  textAlign: 'center',
});
